/* eslint-disable @typescript-eslint/naming-convention */
import { AlkLogger } from "@alk/core";
export default {
  VERSION: '<@VERSION@>',
  APP_NAME: '<@APP_NAME@>',
};
export const STENCIL_NAMESPACE = 'fnx-fx-pad';
export const SPOT_TRADE_RATIO = 1.7;
export const FWD_TRADE_RATIO = 1.4166666667;
export const API_VERSION = 'v3.6';
export const TRADE_API = 'trade-api';
export const AUTHORIZE_API = 'users/authentication';
export const INSTRUMENTS_API = 'instruments';
export const UTILITIES_API = 'utilities';
/**
 * /websocket-channel/{Token}
 * Token parameter is Token for identify user
 * session (received on sfxLogin response), replaced with token value.
 *
 *  var socket = new WebSocket(wss://{WebSite}/trade-api/v3.3/websocket-channel/df2ccadb5d894c029d447cab1e667d42);
 */
export const QUOTES_WS_API = 'websocket-channel';
export const PING_API = `${UTILITIES_API}/ping`;
export const TENOR_TO_DATE_API = `${UTILITIES_API}/tenor-to-date`;
export const QUOTES_SUBS_API = 'quote-subscriptions';
export const RFQ_QUOTES_SUBS_API = 'rfq';
export const ORDERS_LIST_API = 'orders';
const SFX = {
  PROTOCOL: 'https',
  // BASE_URL: 'finastra-sfx-demo-api.olfaconcept.net',
  BASE_URL: '85.119.4.148',
  PORT: '12000',
  CORPORATE_ID: 'demo_firm',
  CREDENTIALS_LABEL: {
    userProp: 'user',
    passwordProp: 'password',
  },
  LOGIN_METHOD: 'post',
  LOGIN_PATH: `${TRADE_API}/${API_VERSION}/${AUTHORIZE_API}`,
  LOGIN_HEADERS: {},
  LOGOUT_METHOD: 'deleter',
  LOGOUT_PATH: `${TRADE_API}/${API_VERSION}/${AUTHORIZE_API}`,
  LOGOUT_HEADERS: {},
  LOGOUT_TOKENS: { skipAuth: false },
};
let loadEnvPromise;
export function loadEnv() {
  if (!Boolean(loadEnvPromise)) {
    loadEnvPromise = fetch('../../manifests/environment.json')
      .then((res) => res.json())
      .then((env) => {
      return {
        ...SFX,
        CORPORATE_ID: env.CORPORATE_ID,
        PROTOCOL: env.PROTOCOL,
        BASE_URL: env.BASE_URL,
        PORT: env.PORT,
      };
    })
      .catch(err => {
      AlkLogger.error(err);
      return SFX;
    });
  }
  return loadEnvPromise;
}
//# sourceMappingURL=app-config.js.map
